import { Alert, Box, Button, TextField } from '@mui/material';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import { useChangesStatusDataMutation } from 'features/changeUserData/api/changeStatusApi';
import { UserProfileType } from 'entities/user/model/types';

type ChangeStatusProps = {
  profile: UserProfileType;
};

type FormDataType = {
  reason: string;
};

export const ChangeStatus = ({ profile }: ChangeStatusProps) => {
  const [changesStatusData, { isLoading: isChangesStatusDataLoading }] = useChangesStatusDataMutation();

  const {
    control,
    handleSubmit,
    formState: { errors: formErrors },
  } = useForm<FormDataType>({
    defaultValues: {
      reason: '',
    },
  });

  const onFormSubmit: SubmitHandler<FormDataType> = ({ reason }) => {
    changesStatusData({
      id: profile.id,
      body: {
        reason,
        status: profile.status === 1 ? 2 : 1,
      },
    });
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(onFormSubmit)}
    >
      <Controller
        name="reason"
        control={control}
        rules={{
          required: 'Причина блокировки обязательна',
        }}
        render={({ field }) => (
          <TextField
            type="text"
            label="Причина блокировки"
            placeholder=""
            fullWidth
            size="small"
            disabled={isChangesStatusDataLoading}
            InputLabelProps={{
              shrink: true,
            }}
            sx={{
              marginBottom: '24px',
            }}
            error={formErrors.reason && true}
            {...field}
          />
        )}
      />
      <p className="title">К примечанию о блокировке будет добавлен ваш комментарий и подпись.</p>
      <Alert
        variant="outlined"
        severity="warning"
        className="worningAlert"
      >
        Пользователь не сможет выводить бонусы и выполнять задания. Разблокировать пользователя сможет только
        Администратор.
      </Alert>
      <Button
        type="submit"
        variant="contained"
        sx={{ textTransform: 'none' }}
      >
        {profile.status === 1 ? 'Заблокировать' : 'Разблокировать'}
      </Button>
    </Box>
  );
};
